export enum STATE_KEYS {
  AUTH = 'AUTH',
  CONFIG = 'CONFIG',
  POSITIONS_FILTER = 'POSITIONS_FILTER',
}

type TStateKeys = `${STATE_KEYS}`;

class LocalState {
  public readonly storeKey: string;
  private _state = new Map<TStateKeys, unknown>();

  constructor(storeKey: string) {
    this.storeKey = storeKey;
    this.update();
  }

  update() {
    try {
      const data = JSON.parse(localStorage.getItem(this.storeKey) || 'null');
      // Раньше ключи домердживались в существующую Map и никогда не удалялись:
      // ключ, стёртый в другой вкладке, оставался в памяти и возвращался
      // в localStorage при следующем set(). Пересобираем состояние с нуля.
      this._state = new Map(Object.entries(data || {}) as [TStateKeys, unknown][]);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      localStorage.removeItem(this.storeKey);
      this._state = new Map();
    }
  }

  get<T = unknown>(key: TStateKeys): T | undefined {
    this.update();
    return this._state.get(key) as T | undefined;
  }

  set(key: TStateKeys, value: unknown) {
    this._state.set(key, value);
    this._save();
  }

  delete(key: TStateKeys) {
    this._state.delete(key);
    this._save();
  }

  private _save() {
    try {
      localStorage.setItem(this.storeKey, JSON.stringify(Object.fromEntries(this._state)));
    } catch (e) {
      // Приватный режим Safari / переполненная квота не должны ронять приложение.
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}

export const localState = new LocalState('POLY');
